import { render, staticRenderFns } from "./workflow-input-settings.vue?vue&type=template&id=674bddbe&scoped=true"
import script from "./workflow-input-settings.vue?vue&type=script&lang=js"
export * from "./workflow-input-settings.vue?vue&type=script&lang=js"
import style0 from "./workflow-input-settings.vue?vue&type=style&index=0&id=674bddbe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674bddbe",
  null
  
)

export default component.exports